let base = "https://www.j-wave.co.jp/jlc/jme/listenplus/";
console.log(location.hostname);
if(location.hostname === "stg-www.j-wave.co.jp"){
	base = "https://stg-www.j-wave.co.jp/jlc/jme/listenplus/";
}
export let setting = {
	ListeningTime: 0,
	loginStatus: base + "get_entry_statement",
	isLogin: false,
	isEntried: false,
	isConnected: false,
	nft: base + "get_owned_nfts",
	weekly: base + "listening_status",
	history: base + "result_history",
	channel: base + "result_recommend"
}